import { Authentication  , gettingAuthenticationClear} from "./login/Authentication";
import { PatientMenu } from "./PatientMenu/PatientMenu";
import { ValidateToken } from "./login/ValidateToken";
import { Appointments , gettingAppointmentsClear } from "./AppointmentsFol/Appointments";
import { ProxyUsers } from "./login/ProxyUsers";
import { clearUserState } from "./login/Authentication";
import { LogoutUser } from "./login/Authentication";
import { Organization } from "./Homescr/Organization"; 
import { Immunization } from "./ImmunizationFol/Immunization";
import { Diagonosis } from "./Homescr/Diagonosis";
import {LabResultByID} from "./Homescr/LabResultByID"
import { PatientProfile } from "./Homescr/PatientProfile";
import { AllergyIntolerance } from "./Allergy/AllergyIntolerance";
import { TreatmentOfChoice } from "./Homescr/TreatmentOfChoice"; 
import { Medication } from "./Homescr/Medication";
import { NewMessages } from "./MessagingFol/NewMessages";
import { gettingNewMessagesClear } from "./MessagingFol/NewMessages";
import { Messaging } from "./MessagingFol/Messaging";
import { PatientScreeningList} from "./ImmunizationFol/PatientScreeningList"
import { GetScreeningTemplateHTML } from "./ImmunizationFol/GetScreeningTemplateHTML";
import { gettingGetScreeningTemplateHTMLClear } from "./ImmunizationFol/GetScreeningTemplateHTML";
import { LabResultsWithoutAttachment } from "./ImmunizationFol/LabResultsWithoutAttachment";
import { LetterAndDocument } from "./ImmunizationFol/LetterAndDocument";
import { Timeline } from "./ImmunizationFol/Timeline";
import { Media } from "./Homescr/Media";
import { Observation } from "./Homescr/Observation";
import { Location } from "./MessagingFol/Location";
import { GetMessageSubject } from "./MessagingFol/GetMessageSubject";
import { MessagingRecipients } from "./MessagingFol/MessagingRecipients";
import { MediaByID , gettingMediaByIDClear } from "./Homescr/MediaByID";
import { MessageByID } from "./MessagingFol/MessageByID";
import { AvailableDateForAppointment , gettingAvailableDateForAppointmentClear } from "./AppointmentsFol/AvailableDateForAppointment";
import {AvailableSlotsForAppointment , gettingAvailableSlotsForAppointmentClear} from "./AppointmentsFol/AvailableSlotsForAppointment"
import { RecheduleAppointment , gettingRecheduleAppointmentClear, } from "./AppointmentsFol/RecheduleAppointment";
import {Logout} from "./login/Logout"
import { StaffProfile } from "./Homescr/StaffProfile";
import { PatientUpdate , gettingPatientUpdateClear} from "./Homescr/PatientUpdate";
import { PatientAlerts } from "./Homescr/PatientAlerts";
import { UpdatePassword , gettingUpdatePasswordClear} from "./login/UpdatePassword"
import {ChangePassword , gettingChangePasswordClear} from "./login/ChangePassword"
import { ForgotPassword , gettingForgotPasswordClear} from "./login/ForgotPassword"
import { LetterAndDocumentByID , gettingLetterAndDocumentByIDClear } from "./Homescr/LetterAndDocumentByID";
export const appServices = {
  PatientUpdate,gettingPatientUpdateClear,
  StaffProfile,
  Logout,
  LetterAndDocument,
  Authentication,gettingAuthenticationClear,
  Timeline,
  LetterAndDocumentByID, gettingLetterAndDocumentByIDClear,
  MediaByID,gettingMediaByIDClear ,
  MessageByID,
  Media,
  Location,
  GetMessageSubject,
  MessagingRecipients,
  Observation,
  UpdatePassword, gettingUpdatePasswordClear,
  ForgotPassword , gettingForgotPasswordClear,
  ChangePassword,gettingChangePasswordClear,
  clearUserState,
  PatientAlerts,
  PatientMenu,
  ValidateToken,
  RecheduleAppointment, gettingRecheduleAppointmentClear,
  AvailableSlotsForAppointment,gettingAvailableSlotsForAppointmentClear,
  AvailableDateForAppointment,gettingAvailableDateForAppointmentClear,
  Appointments, gettingAppointmentsClear,
  ProxyUsers,
  Diagonosis,
  LabResultByID,
  Organization,
  Immunization,
  PatientProfile,
  AllergyIntolerance,
  TreatmentOfChoice,
  Medication,
  PatientScreeningList,
  GetScreeningTemplateHTML,gettingGetScreeningTemplateHTMLClear,
  NewMessages, gettingNewMessagesClear,
  LabResultsWithoutAttachment,
  Messaging,
  LogoutUser,
}